export default "__VITE_ASSET__ClhdIW2c__"